import { useContext } from 'react';

import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { WrapperVariantContext } from '@mui/x-date-pickers/internals';
import Flex from '@components/Flex/Flex';
import { FormattedMessage } from 'react-intl';
import Button from '@components/Button/Button';

export const ActionBar = ({
  onAccept,
  onClear,
  onCancel,
  onSetToday,
  actions,
}: PickersActionBarProps) => {
  const wrapperVariant = useContext(WrapperVariantContext);

  const actionsArray =
    typeof actions === 'function' ? actions(wrapperVariant) : actions;

  if (actionsArray == null || actionsArray.length === 0) {
    return null;
  }

  const menuItems = actionsArray?.map((actionType) => {
    let onClick = null;
    let labelTranslationId = null;
    switch (actionType) {
      case 'clear': {
        onClick = onClear;
        labelTranslationId = 'misc.clear';
        break;
      }
      case 'cancel': {
        onClick = onCancel;
        labelTranslationId = 'misc.cancel';
        break;
      }
      case 'accept': {
        onClick = onAccept;
        labelTranslationId = 'misc.continue';
        break;
      }
      case 'today': {
        onClick = onSetToday;
        labelTranslationId = 'misc.today';
        break;
      }
    }

    return onClick ? (
      <Flex key={actionType} paddingX={1} flex={1}>
        <Button
          data-testid={`actions_${actionType}`}
          onClick={onClick}
          fullWidth
          variant='primary'
          size='large'
          color='primary'
        >
          <FormattedMessage id={labelTranslationId} />
        </Button>
      </Flex>
    ) : null;
  });

  return (
    <Flex flexDirection='row' padding={6} paddingBottom={8}>
      {menuItems}
    </Flex>
  );
};
